"use client";
import { styled } from "@mui/material/styles";
import { Text } from "@nxt-costco-com/forge-components";
import { SpaceLg, ColorGray800, FontSize200, SpaceMd, SpaceXl, ColorGray200, FontSize100 } from "@nxt-costco-com/forge-design-tokens";
import { ONETRUST_BUTTON_ID } from "../../Navigation/SystemDefinedLink/CookieSettings/constants.js";
const columnsContainer = {
  marginLeft: {
    lg: "-24px",
    md: "-16px",
    sm: "-16px"
  }
};
const socialLinks = {
  gap: SpaceLg,
  justifyContent: "center"
};
const formListStyles = {
  a: {
    color: ColorGray800
  },
  div: {
    ".MuiTypography-root": {
      color: ColorGray800
    },
    alignItems: "center",
    display: "flex"
  }
};
const legalSocialStyles = {
  gap: `0 ${SpaceMd}`,
  justifyContent: "center",
  li: {
    ".MuiTypography-root": {
      color: ColorGray800,
      fontSize: FontSize200
    },
    alignItems: "center",
    button: {
      color: `${ColorGray800}!important`,
      fontSize: `${FontSize200}!important`
    },
    display: "flex",
    // override pesky OneTrust styles on CookieSettings button
    [`#${ONETRUST_BUTTON_ID}`]: {
      fontSize: `${FontSize200}!important`
    }
  }
};
const linkListStyles = {
  justifyContent: {
    lg: "space-between",
    md: "center",
    sm: "center"
  },
  li: {
    ".MuiTypography-root": {
      color: ColorGray800
    },
    alignItems: "center",
    button: {
      color: `${ColorGray800}!important`,
      fontSize: `${FontSize200}!important`
    },
    display: "flex"
  },
  marginBottom: SpaceMd
};
const footerContainerStyles = {
  bgcolor: ColorGray200,
  display: "flex",
  flexDirection: "column",
  gap: SpaceXl,
  padding: {
    lg: `${SpaceXl} ${SpaceLg} ${SpaceXl} ${SpaceLg}`,
    md: `${SpaceXl} ${SpaceLg} ${SpaceXl} ${SpaceLg}`,
    xs: `${SpaceLg} ${SpaceMd} ${SpaceXl} ${SpaceMd}`
  },
  width: "100%"
};
const legalSocialContainer = {
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: SpaceMd,
  textAlign: "center"
};
const topDividerStyles = {
  marginBottom: SpaceXl,
  width: "100%"
};
const bottomDividerStyles = {
  display: {
    lg: "block",
    md: "block",
    sm: "none",
    xs: "none"
  },
  marginBottom: SpaceMd,
  marginTop: "-18px",
  width: "100%"
};
const copyrightStyles = {
  color: ColorGray800,
  fontSize: FontSize100
};
const displayMobile = {
  display: {
    lg: "none",
    md: "none",
    sm: "block",
    xs: "block"
  }
};
const displayTablet = {
  display: {
    lg: "none",
    md: "block",
    sm: "none",
    xs: "none"
  }
};
const displayDesktop = {
  display: {
    lg: "block",
    md: "none",
    sm: "none",
    xs: "none"
  }
};
const displayDesktopTablet = {
  display: {
    lg: "block",
    md: "block",
    sm: "none",
    xs: "none"
  }
};
const LanguageAriaDescribedByHidden = styled(Text, {
  shouldForwardProp: () => true
})(() => ({
  display: "none"
}));
export {
  LanguageAriaDescribedByHidden,
  bottomDividerStyles,
  columnsContainer,
  copyrightStyles,
  displayDesktop,
  displayDesktopTablet,
  displayMobile,
  displayTablet,
  footerContainerStyles,
  formListStyles,
  legalSocialContainer,
  legalSocialStyles,
  linkListStyles,
  socialLinks,
  topDividerStyles
};
